import { useAtomValue, useSetAtom } from 'jotai';
import React, { useEffect } from 'react';

import {
  forceRefreshStatusAtom,
  forceRerenderUIAtom,
  epListingDataAtom,
  endpointsStatusDataAtom,
} from './state';

const StatusUpdater = () => {
  const listingData = useAtomValue(epListingDataAtom);
  const statusListingData = useAtomValue(endpointsStatusDataAtom);
  const setStatusForceRefresh = useSetAtom(forceRefreshStatusAtom);
  const setForceRerenderUI = useSetAtom(forceRerenderUIAtom);

  useEffect(() => {
    // Set up a recurring timer to force reload repo data every 10 seconds
    const intervalId = setInterval(
      () => setStatusForceRefresh(Math.random().toString()),
      60000,
    );

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array ensures this effect runs only once on component mount

  useEffect(() => {
    const rows = listingData?.items;
    const statusRows = statusListingData;
    if (rows && statusRows) {
      // update the status in the listing data
      rows.forEach((row) => {
        const statusRow = statusRows.find((r) => r.id === row.id);
        if (statusRow) {
          // update the data
          row['scan_in_progress'] = statusRow['scan_in_progress'];
          row['scan__launch_datetime'] = statusRow['vm_scanned_date'];
        }
      });
      setForceRerenderUI(Math.random().toString());
    }
  }, [statusListingData]);

  return <></>;
};

export default StatusUpdater;
